// Set config defaults when creating the instance
import axios from "axios";

let URL = "http://localhost:9000"
if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    // dev code
} else {
    URL = "https://db-be.onrender.com"
}

const instance = axios.create({
    baseURL: URL
});

export const httpInstance = (token) => {
    if (token) {
        instance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }

   return instance;
}